import clsx from "clsx";

export type TapeProps = {
  /** Extra positioning classes; the caller decides where the strip lands. */
  className?: string;
  /** Degrees of rotation, from the entry's seed. */
  rotation?: number;
  /** Short strips hold a corner; long strips hold an edge. */
  length?: "short" | "long";
};

/**
 * A strip of gummed linen tape. Translucent, slightly warm, with torn ends and
 * a faint sheen — the thing actually holding the print to the sheet.
 */
export function Tape({ className, rotation = 0, length = "short" }: TapeProps) {
  return (
    <span
      aria-hidden="true"
      style={{ transform: `rotate(${rotation}deg)` }}
      className={clsx(
        "pointer-events-none absolute block",
        length === "short" ? "h-5 w-14" : "h-5 w-28",
        // Gummed tape: milky, translucent, mixed from the paper token itself.
        "bg-[color-mix(in_oklab,var(--color-paper-deep)_62%,transparent)]",
        "shadow-[0_1px_2px_color-mix(in_oklab,var(--color-ink)_16%,transparent)]",
        // Torn, fibrous ends.
        "[clip-path:polygon(0_12%,4%_0,9%_14%,15%_2%,22%_16%,100%_10%,97%_0,100%_88%,96%_100%,90%_86%,84%_98%,77%_84%,2%_92%,4%_100%,0_88%)]",
        className,
      )}
    >
      <span className="absolute inset-x-0 top-1/2 block h-px -translate-y-1/2 bg-[color-mix(in_oklab,white_50%,transparent)]" />
    </span>
  );
}
